import { Link } from 'react-router-dom';
import { Shield } from 'lucide-react';
import { isNativePlatform } from '../native';

const COPY = {
  guest: {
    title: 'Members only',
    body: 'This part of Iron Forums is for members. Ask your facilitator about joining.',
  },
  paused: {
    title: 'Limited access',
    body: 'Your app access is limited, so this area is unavailable. You still have guest access — Home, your Snapshot, this month’s Library, and your Forum’s next meeting. Ask your facilitator to restore full access.',
  },
  lapsed: {
    title: 'Limited access',
    body: isNativePlatform
      ? 'Your membership payment didn’t go through, so this area is unavailable for now. You still have Home, your Snapshot, this month’s Library, and your Forum’s next meeting. Your facilitator can help you restart your membership.'
      : 'Your membership payment didn’t go through, so this area is unavailable for now. You still have Home, your Snapshot, this month’s Library, and your Forum’s next meeting. Restart your membership to get full access back.',
  },
};

export default function MembersOnly({
  reason = 'guest',
}: {
  reason?: 'guest' | 'paused' | 'lapsed';
}) {
  const copy = COPY[reason];
  const canRestart = reason === 'lapsed' && !isNativePlatform;
  return (
    <div className="max-w-lg mx-auto mt-12 bg-white rounded-2xl p-8 shadow-sm text-center">
      <div className="mx-auto w-12 h-12 rounded-full bg-navy/10 flex items-center justify-center mb-4">
        <Shield className="text-navy" size={22} />
      </div>
      <h1 className="text-2xl font-bold text-navy">{copy.title}</h1>
      <p className="mt-3 text-gray-600">{copy.body}</p>
      <div className="mt-6 flex flex-wrap justify-center gap-3">
        {canRestart && (
          <Link
            to="/payment"
            className="inline-block px-5 py-2.5 bg-gold text-white rounded-lg font-medium hover:bg-gold-dark transition"
          >
            Restart membership
          </Link>
        )}
        <Link
          to="/"
          className="inline-block px-5 py-2.5 bg-navy text-white rounded-lg font-medium hover:bg-navy-dark transition"
        >
          Back to Home
        </Link>
      </div>
    </div>
  );
}
